import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';

export interface GenTechnologyCategoryRequest {
    task_id: string;
    /** 操作类型 */
    operate_type?: string;
}

export type GenTechnologyCategoryResponse = string;

export const GenTechnologyCategoryApi = Symbol.for('GenTechnologyCategoryApi');

export interface GenTechnologyCategoryApi {
    genTechnologyCategory(data: GenTechnologyCategoryRequest): PsHttpSSE<SpecificationStreamContent<GenTechnologyCategoryResponse>>;
}
